<template>
  <TopNav />

  <div class="h-16"></div>
  <slot />
  <Footer />
  <div v-html="Sprite"></div>
</template>

<script lang="ts" setup>
import Sprite from "@/assets/sprite.svg?raw";
import Footer from "@/components/Footer.vue";
import TopNav from "../components/TopNav.vue";
import { sentryBrowserConfig } from "../sentry.browser.config";

sentryBrowserConfig();
</script>
